import NavigationHelper from '@/Management/NavigationHelper';
import AssociationNavigator from '@/Management/AssociationNavigator';
import { IAssociationNavigator, IListViewParameter } from '#/CoreFrameInterfaces';
import RADApplication from '@/Management/RADApplication';
import ComponentManager from '@/Management/ComponentManager';

export default class DefaultAssociationNavigator extends AssociationNavigator implements IAssociationNavigator {

    constructor() {
        super();
    }

    public navigateAssociation(typeName, selectedPDO, optionalParams: IListViewParameter | any, openInNewWindow: boolean = false): void {
        if (selectedPDO === null || selectedPDO === undefined) {
            return;
        }


        if (optionalParams != null && optionalParams.contextSource === 'SV') {
            if (RADApplication.getInstance().isSystemParamSetAndTrue('OpenDetailViewFromSummary')) {
                this.openDetailView(selectedPDO, typeName, optionalParams, openInNewWindow);
            }
            else {
                this.openListView(selectedPDO, typeName, optionalParams, openInNewWindow);
            }
        }
        else {
            this.openDetailView(selectedPDO, typeName, optionalParams, openInNewWindow);
        }
    }
} // end of class DefaultAssociationNavigator

ComponentManager.setUtility('AssociationNavigator', DefaultAssociationNavigator, 'RADPresentation.HTMLClient.DefaultViewExtensions');